module.exports = __webpack_public_path__ + "static/media/fitness_center.83202055.svg";